import React, {useEffect} from 'react';
import UserContent from './app-main-content/UserContent';
import AdminContent from './adminContent/AdminContent';
import AuthContent from './app-main-content/AuthContent';
import { checkAuthenticated, load_user } from './actions/AuthActions';
import { useDispatch } from 'react-redux'
import { login } from './actions/AuthActions';

const Content = (props) => {

    const dispatch = useDispatch()

    const params = new URLSearchParams(window.location.search);
    const value = params.get("auth");

    useEffect(()=>{ 
        if(value && value === '1'){
            dispatch(login('newUser@email.com', "guestB2B"))
        } else {
            dispatch(checkAuthenticated())
            dispatch(load_user())
        }
      },[])

  return (
    <>
      <UserContent/>
      <AuthContent/>
      <AdminContent/>
    </>
  );
}

export default Content;